import styled from 'styled-components';

import { min } from '../../utils/breakpoints';

const StyledIcon = styled.span`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(props) =>
    props.icon === 'inverter' ? props.theme.colors.icons.inverterIconBackground : props.theme.colors.gradients.info};

  ${min.sm} {
    width: 60px;
    height: 60px;
  }

  img {
    width: 20px;
    height: 20px;

    ${min.sm} {
      width: 30px;
      height: 30px;
    }
  }
`;

export default StyledIcon;
